import React, { useState, useEffect } from 'react';
import JotformEmbed from 'react-jotform-embed';

const PayoutForm = (props) => {   
   return (
       <div className="mb-4">
            <div>
                <JotformEmbed src="https://form.jotform.com/212372196691056" />
            </div>
       </div>
       
   )
};

export default PayoutForm;
